import {LinkType} from '@workspaces/link';

export const adminLinks: LinkType = {
  PROD: 'https://nemesis.editions-tissot.fr/',
  PREPROD: 'https://nemesis-preprod.editions-tissot.fr/',
  DEV: 'https://nemesis-dev.editions-tissot.fr/',
  LOCAL: 'https://nemesis-app.tissot-local.com',
};

export const appLinks: LinkType = adminLinks;
